var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"医療保険","authDiv":_vm.authDiv,"headers":_vm.medHeaders,"items":_vm.items,"item_class":_vm.medItemsRowBackground},on:{"makenew":_vm.medCreate,"repair":_vm.medRepair,"copy":_vm.medCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }